import { LinkIcon, Typography } from '@libs/components';
import { useCopy } from '@libs/hooks';
import { CopyIcon } from 'src/assets';
import { navigateToUrl } from 'src/helpers';
import {
  ActionButton,
  AssetInfoTitle,
  CopyLinkContainer,
  FlexCenter,
  FlexColumn,
} from './styles';

type CopyLinkProps = {
  title: string;
  description: string;
  link: string;
  color?: string;
};

export const CopyLink: React.FC<CopyLinkProps> = ({
  title,
  description,
  link,
  color,
}) => {
  const { handleCopy } = useCopy(title);

  return (
    <CopyLinkContainer>
      <FlexColumn>
        <AssetInfoTitle type="caption" fontFamily="primaryMedium">
          {title}
        </AssetInfoTitle>
        <Typography type="bodyButton" fontFamily="primaryBold">
          {description}
        </Typography>
      </FlexColumn>
      <FlexCenter>
        <ActionButton onClick={handleCopy} color={color}>
          <CopyIcon />
        </ActionButton>
        <ActionButton onClick={() => navigateToUrl(link, true)} color={color}>
          <LinkIcon />
        </ActionButton>
      </FlexCenter>
    </CopyLinkContainer>
  );
};
